

export default {
    address: "",
    assigned_manager: "",
    assigned_operatives: [],
    assigned_supervisor: "",

    end_date: "",
    job_id: "",
    job_name: "",
    jobpack_type: "",
    location_lat: "53.35046029646121",
    location_long: "-6.2605484635565745",
    start_date: "",
    job_vehicles: [],
    status: "active",
    calendar_color: "",

    job_stage: "Planning",
    departments: null,
    areas: null,
    qr_code_url: "",
};
